module.exports = __webpack_public_path__ + "static/1-6646047733413dd09164260d812d384a.png";